export class FilterControl {
    Type: string;
    DataSource: string | null;
    SelectProperty: string | null;
    DisplayProperty: string | null;
}